export default "__VITE_ASSET__phluNktm__"